module.exports = __webpack_public_path__ + "static/img/10.aba4706.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mOfficial/10.png
// module id = PlkB
// module chunks = 1